export default __webpack_public_path__ + "static/media/photo-1502937406922-305bb2789e95.647d289b.jpeg";